import React from 'react'
import { Container, Row, Col, Image } from 'react-bootstrap'

function Footer() {
  return (

        <footer>
            <Container>
               

                <Row>
                    <Col className="text-center py-3">
                        <a href="https://www.instagram.com/rayquazaboi?utm_source=qr&stkn=eWk0cWd4MDQ0ZnRs">
                        <Image src="/static/images/instagram2.png"  style={{width:'30px', height:'auto', margin:'5px'}}  />
                        </a>
 
                        <a href="mailto:rayquazastore2@gmail.com">
                        <Image src="/static/images/gmail2.png"  style={{width:'30px', height:'auto', margin:'5px'}}  />
                        </a>
                        <a href="https://t.me/+lcYksKUQBOU1MWM8">
                        <Image src="/static/images/telegram.png"  style={{width:'30px', height:'auto', margin:'5px'}}  />
                        </a>
                        <a href="https://www.vinted.it/member/56126830-rayquazaita">
                        <Image src="/static/images/vinted.png"  style={{width:'30px', height:'auto', margin:'5px'}}  />
                        </a>
                        {/* <a href="https://www.instagram.com/notsmokable/">
                        <Image src="/static/images/instagram.png" style={{width:'30px', height:'auto', margin:'5px'}}   />
                        </a> */}
                        <a href="https://www.ebay.it/usr/rayquazastore2">
                        <Image src="/static/images/ebay.png" style={{width:'30px', height:'auto', margin:'5px'}}  />
                        </a>
                        <a href="https://www.tiktok.com/@rayquaza_ita?_r=1&_t=ZN-99K8E3TBJTi">
                        <Image src="/static/images/tiktok.png" style={{width:'30px', height:'auto', margin:'5px'}}  />
                        </a>
                        
                    </Col>
                </Row>

                <Row>
                    <Col className="text-center py-2">
                        <a href="https://www.iubenda.com/privacy-policy/62630212" target="_blank" rel="noreferrer">Privacy Policy</a>
                        {' '}|{' '}
                        <a href="https://www.iubenda.com/privacy-policy/62630212/cookie-policy" target="_blank" rel="noreferrer">Cookie Policy</a>
                    </Col>
                </Row>

                <Row>
                    <Col className="text-center py-3">Copyright &copy; RayquazaItalia</Col>
                </Row>

            </Container>
        </footer>
    
  )
}

export default Footer